export default ":host {\n  display: block;\n}";